import { render, staticRenderFns } from "./FulfillmentHero.vue?vue&type=template&id=4b9a980c&scoped=true&"
import script from "./FulfillmentHero.vue?vue&type=script&lang=js&"
export * from "./FulfillmentHero.vue?vue&type=script&lang=js&"
import style0 from "./FulfillmentHero.vue?vue&type=style&index=0&id=4b9a980c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9a980c",
  null
  
)

export default component.exports